import React, { useState } from "react";

export default function SecuritySettings() {
  const [twoFAEnabled, setTwoFAEnabled] = useState(false);

  const handleToggle = () => {
    // TODO: Update 2FA setting in backend
    setTwoFAEnabled(!twoFAEnabled);
    alert(`Two-factor authentication ${!twoFAEnabled ? "enabled" : "disabled"}.`);
  };

  return (
    <section className="bg-gray-50 dark:bg-gray-900 p-6 rounded-lg shadow-md max-w-xl mx-auto">
      <h3 className="text-2xl font-semibold mb-6 text-gray-900 dark:text-white">Security Settings</h3>

      <div className="flex items-center space-x-4">
        <label htmlFor="twoFA" className="text-gray-700 dark:text-gray-300 font-medium">
          Enable Two-Factor Authentication (2FA)
        </label>
        <input
          id="twoFA"
          type="checkbox"
          checked={twoFAEnabled}
          onChange={handleToggle}
          className="form-checkbox h-5 w-5 text-blue-600"
        />
      </div>
    </section>
  );
}
